import React from "react";
import "./BoxWithShadow.css";

export default function BoxWithShadow({ children }) {
  return (
    <div className="box-wrapper">
      <div className="shadow-box" role="note">
        {children}
      </div>
    </div>
  );
}
